import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { SBAComboBox, SBADropDown  } from "../../UiComponents/SBADropDown";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { useLocation } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { sbaAxios } from "../../utils/sbaAxios";
import { getAssetLiquidity, getLiquidityBasicsDS, getLiquidityFromDateDS, postLiquidityPayout, postLiquidityTerms, deleteLiquidityTermAPI, deleteLiquidityPayoutsAPI, getFirstRedemptionMonthsAPI } from "../../../config/apiConfig";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBNotify } from "../../utils/sbNotify";
import { Modal } from "react-bootstrap";

function checkIfNumber(value) {
    if (value === null || value === "") {
      return false; 
    } else if (!isNaN(value)) {
      return true; 
    } else {
      return typeof value === 'number'; 
    }
}

export const Liquidity = () => {
    const params = useParams();
    const dispatch=useDispatch();
    // location data

    const AssetId = params.Asset;
    const Gstate = useSelector((state) => state) || {};
    const shareClassList = Gstate?.assetShareClass?.assetShareClass || [];


    const [loading, setLoading] = useState(false);
    const [liquidityData, setLiquidityData] = useState([]);
    const [shareClassItem, setShareClassItem] = useState();
    const [render,setRender] = useState(true);
    useEffect(() => {
        if (shareClassItem?.ShareClassId)
        {
            setLoading(true);
            sbaAxios({ url: `${getAssetLiquidity}shareClassId=${shareClassItem?.ShareClassId}` }).then((response) => {
                    setLiquidityData(response);
                    setLoading(false);
                }).catch(error => { setLoading(false); console.log(error, 'error fetching Liquidity data') });
        }
    
      
    }, [shareClassItem,render]);
    useEffect(() => {
        if(shareClassList.length>0)
        {
            setShareClassItem(shareClassList[0]);
        }
    }, [shareClassList]);

    const ShareClassDropDownChanged = (e) => {
        if (e.value)
            setShareClassItem(e.value);
        // else 
        //     setShareClassItem(null);
    }
    return (
        <div className="liquidity-tab">
            {loading ? <><LoadingScreen /></> : <>
                <div className="liquidityDetailsContainer">
                    <div className="row">
                        <div className="col-md-2 ms-auto">
                            <span>Share Class</span>
                            <SBADropDown  data={shareClassList} value={shareClassItem} textField={'ShareClassName'} dataItemKey={'ShareClassId'} onChange={ShareClassDropDownChanged} />
                        </div>
                    </div>
                    <div>
                        <button
                            className={`non-gappable-button  selected-non-gappable-button`}
                        >
                            Terms & Payouts
                        </button>
                        {/* <button
                            className={`non-gappable-button`}
                        >
                            Modeling
                        </button> */}
                    </div>
                    <div>
                        <Terms termsData={liquidityData.RedemptionTerms || []} setRender={setRender} render={render} shareClassId={shareClassItem?.ShareClassId}/>
                        <Payouts payoutData={liquidityData.RedemptionPayouts || []} setRender={setRender} render={render} shareClassId={shareClassItem?.ShareClassId}/>
                    </div>
                </div>
            </>}
        </div>
       
    );
};




const defColDef = { flex: 1, filter: "agTextColumnFilter", minWidth: 100,resizable:true };


// Terms Section
const nullTerms = {
    "RedemptionTermsId": null,
    "ShareClassid": null,
    "LockType": null,
    "LockTypeName": null,
    "PenaltyPercent": null,
    "RedemptionFeePercent": null,
    "RollingLockup": false,
    "Anniversary": false,
    "RedemptionFrequencyId": null,
    "RedemptionFrequencyName": null,
    "LockupFrequencyId": null,
    "LockupFrequencyName":null,
    "LockupStart": null,
    "LockupEnd": null,
    "RequiredNoticeFrequencyId": null,
    "RequiredNoticeFrequencyName": null,
    "RequiredNotice": null,
    "FirstRedemptionMonth": null,
    "FirstRedemptionMonthName":null,
    "InvestorGateFrequencyId": null,
    "InvestorGateFrequencyName": null,
    "InvestorGatePercent": null,
    "InvestorGateCapResetFrequencyId": null,
    "InvestorGateCapResetFrequencyName": null,
    "InvestorGateMaxCapPercent": null,
    "InvestorGateUseNav": null,
    "AssetGateFrequencyId": null,
    "AssetGateFrequencyName": null,
    "AssetGatePercent": null,
    "Notes": null,
    "ModifiedBy": null,
    "ModifiedDate": null
};
const Terms = ({ termsData , setRender ,render ,shareClassId}) => {
    const [terms,setTerms]=useState([]);
    const [selectedTerm, setSelectedTerm] = useState(nullTerms);
    const [isEditORInsert, setIsEditORInsert] = useState(false);
    const [drawerMode, setDrawerMode] = useState("");
    const [showSelectedTerms,setShowSelectedTerms]=useState(false);
    const [deleteTerms,setDeleteTerms]=useState(false);
    const termsRef=useRef();
    const Gstate = useSelector((state) => state) || {};
    const isEditable =Gstate.authorizationData.isEditable;
    const shareClassList = Gstate?.assetShareClass?.assetShareClass || [];
    useEffect(()=>{
        setShowSelectedTerms(false);
        setTerms(termsData);
    },[]);

    const termsColDef = [
        { field: "LockTypeName", headerName: "Lock Type" },
        { field: "Anniversary", headerName: "Anniversary" },
        { field: "RollingLockup", headerName: "Rolling Lock" },
        { field: "RequiredNotice", headerName: "Required Notice" ,valueFormatter:(e)=>{return e.data.RequiredNotice +" "+e.data.RequiredNoticeFrequencyName} },
        { field: "RedemptionFrequencyName", headerName: "Redemption Frequency" },
        { field: "FirstRedemptionMonthName", headerName: "First Redemption Month" },
        { field: "PenaltyPercent", headerName: "Penalty %" },
        { field: "LockupFrequencyName", headerName: "Lockup Frequency" },
        { field: "LockupStart", headerName: "Lockup Start" },
        { field: "LockupEnd", headerName: "Lockup End" },
        // { field: "LockupFrequencyName", headerName: "Lockup Frequency" },
        { field: "", headerName: "Action"  ,minWidth: 100,cellRenderer:(rowData)=>{return <div className="actions-cell"><i className="fas fa-edit mx-1" style={{ color: isEditable === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}  onClick={()=>{editTerms(rowData)}} ></i><i className="fas fa-trash mx-1"  style={{ color: isEditable === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }}  onClick={()=>{OpendeleteTerms(rowData)}} ></i></div>} },

    ];
    const editTerms = (e) => {
        setSelectedTerm(e.data);
        setIsEditORInsert(true);
        setDrawerMode("Edit");
    };
    const OpendeleteTerms=(e)=>{
        setDeleteTerms(true);
        setSelectedTerm(e.data);
    }
    const deleteLiquidityTerms=()=>{
        const deleteUrl=`${deleteLiquidityTermAPI}${selectedTerm.RedemptionTermsId}`;
          sbaAxios({url:deleteUrl}).then(response=>{
            setDeleteTerms(false);
            setRender(!render);
            delayedSBNotify({Msg:"Redemption Term Deleted Successfully"});
          }).catch(error=>{
            console.log(error,'Error Deleting Redemption Terms')
          });
    }
    const setTermsData = (e) => {
        setSelectedTerm(e.data);
        setShowSelectedTerms(true);
    }
    const removeSelectedTerms = () => {
         setShowSelectedTerms(false);
    }
    return <div className="my-4">
        Terms

        <div className="detail p-2">
            <div className="row m-0">
            {shareClassList.length>0 && <div className="col-md-1 ms-auto" style={{ width: "max-content" }} >
                    <i className="fa-solid fa-add ms-auto text-success" disabled={!isEditable} onClick={() => { setIsEditORInsert(true);setDrawerMode("Add") }}></i>
                </div>}
            </div>
            <div className="ag-theme-alpine mb-3">
                <AgGridReact ref={termsRef} rowData={terms} columnDefs={termsColDef} onRowDoubleClicked={removeSelectedTerms} defaultColDef={defColDef} rowSelection="single" onRowClicked={setTermsData} />
            </div>
            {showSelectedTerms && <>
            <div className="row p-3 border-bottom m-0">
                <div className="col-md-2">
                    <span><input type="checkbox" className="me-2" checked={selectedTerm.RollingLockup}/>Rolling Lock</span>
                </div>
                <div className="col-md-2">
                    <span><input type="checkbox" className="me-2" checked={selectedTerm.Anniversary}/>Anniversary</span>
                </div>
                <div className="col-md-2">
                    <span>Required Notice </span>
                    <p className="fw-medium"> <span>{selectedTerm?.RequiredNotice} {selectedTerm?.RequiredNoticeFrequencyName}</span></p>
                </div>
                <div className="col-md-2">
                    <span>Redemption Frequency</span>
                    <p className="fw-medium">{selectedTerm.RedemptionFrequencyName}</p>
                </div>
                <div className="col-md-2">
                    <span>First Redemption Month</span>
                    <p className="fw-medium">{selectedTerm.FirstRedemptionMonthName}</p>
                </div>
            </div>
            <div className="row p-3 border-bottom m-0">
                <div className="col-md-2">
                    <span>Lock Type</span>
                    <p className="fw-medium">{selectedTerm.LockTypeName}</p>
                </div>
                <div className="col-md-2">
                    <span>Penalty % </span>
                    <p className="fw-medium">{!selectedTerm.PenaltyPercent ? 0 : selectedTerm.PenaltyPercent} %</p>
                </div>
                <div className="col-md-2">
                    <span>Fee %</span>
                    <p className="fw-medium">{!selectedTerm.RedemptionFeePercent ? 0 : selectedTerm.RedemptionFeePercent} %</p>

                </div>
                <div className="col-md-2">
                    <span>Lockup Frequency</span>
                    <p className="fw-medium">{selectedTerm.LockupFrequencyName}</p>

                </div>
                <div className="col-md-2">
                    <span>Lockup Start</span>
                    <p className="fw-medium">{selectedTerm.LockupStart}</p>
                </div>
                <div className="col-md-2">
                    <span>Lockup End</span>
                    <p className="fw-medium">{selectedTerm.LockupEnd}</p>
                </div>
            </div>
            <div className="row p-3 border-bottom m-0">
                <div className="col-md-2">
                    <span>Investor Gate Frequency</span>
                    <p className="fw-medium">{selectedTerm.InvestorGateFrequencyName}</p>
                </div>
                <div className="col-md-2">
                    <span>Investor Gate %</span>
                    <p className="fw-medium">{!selectedTerm.InvestorGatePercent ? 0 : selectedTerm.InvestorGatePercent} %</p>
                </div>
                <div className="col-md-2">
                    <span>Investor Gate Cap Reset Frequency</span>
                    <p className="fw-medium">{selectedTerm.InvestorGateCapResetFrequencyName}</p>
                </div>
                <div className="col-md-2">
                    <span>Investor Gate Max Cap Percent</span>
                    <p className="fw-medium">{!selectedTerm.InvestorGateMaxCapPercent ? 0 : selectedTerm.InvestorGateMaxCapPercent} %</p>
                </div>
                <div className="col-md-2">
                    <span>Use NAV in calculations</span>
                    <p><input className="me-2" type="checkbox" checked={selectedTerm.InvestorGateUseNav} /></p>
                </div>
            </div>
            <div className="row p-3">
                <div className="col-md-2">
                    <span>Asset Gate Frequency</span>
                    <p className="fw-medium">{selectedTerm.AssetGateFrequencyName}</p>
                </div>
                <div className="col-md-2">
                    <span>Asset Gate %</span>
                    <p className="fw-medium">{!selectedTerm.AssetGatePercent ? 0 :selectedTerm.AssetGatePercent}</p>

                </div>
                <div className="col-md-2">
                    <span>Comments</span>
                    <br />
                    <p>{selectedTerm.Notes}</p>
                </div>
            </div></>}
        </div>
        <SBADrawer size={'lg'} open={isEditORInsert} setOpen={setIsEditORInsert} title={'Insert Or Update Terms'}><><InsertAndUpdateTerms selectedTerm={selectedTerm} setSelectedTerm={setSelectedTerm} mode={drawerMode} setDrawerOpen={setIsEditORInsert} setRender={setRender} render={render} shareClassId={shareClassId} /></></SBADrawer>
        <LiquidityDeleteModal showModal={deleteTerms} title={"Delete Redemption Terms ?"} setShowModal={setDeleteTerms} deleteLiquidity={deleteLiquidityTerms} >
        <p>
          The selected Liquidity Redemption Term will be deleted permanently. Are you sure?
        </p>
        </LiquidityDeleteModal>
    </div>
};
const InsertAndUpdateTerms = ({ selectedTerm, setSelectedTerm , mode ,setDrawerOpen , setRender ,render,shareClassId}) => {
    const Gstate = useSelector((state) => state) || {};
    // Data source variables declared Here
    const LiquidityRequriedNotice =Gstate.common.LiquidityRequriedNotice;
    const LiquidityLockUpType  =Gstate.common.LiquidityLockUpType ;
    const LiquidityLockUpFrequency =Gstate.common.LiquidityLockUpFrequency;
    const Frequency1 =Gstate.common.Frequency1;
    const Frequency2 =Gstate.common.Frequency2;
    const [firstRedemptionDS,setFirstRedemptionDS]=useState([]);

    const [Terms,setTerms]=useState(()=>{if(mode==="Add")return nullTerms; else return selectedTerm})
    
    const [RedemptionFrequency,setRedemptionFrequency]=useState({FrequencyId:Terms.RedemptionFrequencyId ,"FrequencyName": Terms.RedemptionFrequencyName});
    const [NoticeFrequency,setNoticeFrequency]=useState({EnumValue:Terms.RequiredNoticeFrequencyId ,EnumName: Terms.RequiredNoticeFrequencyName});
    const [LockType,setLockType]=useState({EnumValue:Terms.LockType,EnumName:Terms.LockTypeName});
    const [LockUpFrequency,setLockUpFrequency]=useState({EnumValue:Terms.LockupFrequencyId,EnumName:(Terms.InvestorGateFrequencyName==="Not Defined" || !Terms.LockupFrequencyName )? "Please Select" :Terms.LockupFrequencyName});
    const [InvestorGate,setInvestorGate]=useState({FrequencyId:Terms.InvestorGateFrequencyId ,FrequencyName:(Terms.InvestorGateFrequencyName==="Not Defined" || !Terms.InvestorGateFrequencyName) ? "Please Select" : Terms.InvestorGateFrequencyName});
    const [InvestorGateCapReset,setInvestorGateCapReset]=useState({FrequencyId:Terms.InvestorGateCapResetFrequencyId ,FrequencyName:(Terms.InvestorGateCapResetFrequencyName ==="Not Defined" || !Terms.InvestorGateCapResetFrequencyName  )? "Please Select" : Terms.InvestorGateCapResetFrequencyName});
    const [AssetGateFrequency,setAssetGateFrequency]=useState({FrequencyId:Terms.AssetGateFrequencyId ,FrequencyName:(Terms.AssetGateFrequencyName ==="Not Defined" ||  !Terms.AssetGateFrequencyName )? "Please Select" : Terms.AssetGateFrequencyName});
    const [firstRedemptionMonth,setFirstRedemptionMonth]=useState({"MonthNr": 0,"MonthName":"","IsDefault": false})
    useEffect(()=>{
        getDefaultFirstRedemptionMonth(Terms?.RedemptionFrequencyId);
    },[])
    useEffect(()=>{
        setRedemptionFrequency({FrequencyId:Terms.RedemptionFrequencyId ,"FrequencyName": Terms.RedemptionFrequencyName})
        setNoticeFrequency({EnumValue:Terms.RequiredNoticeFrequencyId ,EnumName: Terms.RequiredNoticeFrequencyName});
        setLockType({EnumValue:Terms.LockType,EnumName:Terms.LockTypeName});
        setLockUpFrequency({EnumValue:Terms.LockupFrequencyId,EnumName:(Terms.LockupFrequencyName==="Not Defined" ||  !Terms.LockupFrequencyName )? "Please Select"  :Terms.LockupFrequencyName });
        setInvestorGate({FrequencyId:Terms.InvestorGateFrequencyId ,FrequencyName:(Terms.InvestorGateFrequencyName==="Not Defined" || !Terms.InvestorGateFrequencyName) ? "Please Select" : Terms.InvestorGateFrequencyName});
        setInvestorGateCapReset({FrequencyId:Terms.InvestorGateCapResetFrequencyId ,FrequencyName:(Terms.InvestorGateCapResetFrequencyName ==="Not Defined" || !Terms.InvestorGateCapResetFrequencyName)? "Please Select" : Terms.InvestorGateCapResetFrequencyName});
        setAssetGateFrequency({FrequencyId:Terms.AssetGateFrequencyId ,FrequencyName:(Terms.AssetGateFrequencyName ==="Not Defined" ||  !Terms.AssetGateFrequencyName )? "Please Select" : Terms.AssetGateFrequencyName});
    },[Terms]);
    const getDefaultFirstRedemptionMonth=(RedemptionFrequencyId)=>{
        if(RedemptionFrequencyId)
        {
            sbaAxios({url:getFirstRedemptionMonthsAPI+RedemptionFrequencyId}).then(response=>{
                setFirstRedemptionDS(response);
                if(response.length>0)
                {
                   const defaultMonth=response.find(item=>(item.IsDefault));
                   setFirstRedemptionMonth(defaultMonth);
                   setTerms((value)=>({...value,FirstRedemptionMonth:defaultMonth.MonthNr,FirstRedemptionMonthName:defaultMonth.MonthName}));
                }
                else{
                   setFirstRedemptionMonth({"MonthNr":0,"MonthName": "","IsDefault": false}); 
                   setTerms((value)=>({...value,FirstRedemptionMonth:0,FirstRedemptionMonthName:""}));
                }
                
            }).catch(e=>{
                setFirstRedemptionDS([]);
                console.log(e,'Error Fetching data for First Redemption Frequency')
            })
        }
    }
    const updateRedemption = (e) => {
        if (e.value) {
            const RedemptionFrequency = e.value;
            setRedemptionFrequency(RedemptionFrequency);
            setTerms((value) => ({ ...value, RedemptionFrequencyId: RedemptionFrequency.FrequencyId, RedemptionFrequencyName: RedemptionFrequency.FrequencyName }));
            getDefaultFirstRedemptionMonth(RedemptionFrequency.FrequencyId);
        };
    }
    const updateLockType=(e)=>{
        if (e.value) {
        const LockType=e.value;
        setLockType(LockType);
        setTerms((value)=>({...value,LockType:LockType.EnumValue,LockTypeName:LockType.EnumName}));
        }
        else{}

    }
    const updateLockUpFrequency=(e)=>{
        if (e.value) {
        const LockUpFrequency=e.value;
        setLockUpFrequency(LockUpFrequency);
        setTerms((value)=>({...value,LockupFrequencyId:LockUpFrequency.EnumValue,LockupFrequencyName:LockUpFrequency.EnumName}));
    }
    else{}

    }
    const updateInvestorGate = (e) => {
        if (e.value) {
            const InvestorGateValue = e.value;
            setInvestorGate(InvestorGateValue);
            setTerms((value) => ({ ...value, InvestorGateFrequencyId: InvestorGateValue.FrequencyId, InvestorGateFrequencyName: InvestorGateValue.FrequencyName, InvestorGateUseNav: Terms.InvestorGateUseNav }));
        }
        else{}

    }
    const updateInvestorGateCapReset=(e)=>{
        if (e.value) {
        const InvestorGateCap=e.value;
        setInvestorGateCapReset(InvestorGateCap);
        setTerms((value)=>({...value,InvestorGateCapResetFrequencyId:InvestorGateCap.FrequencyId,InvestorGateCapResetFrequencyName:InvestorGateCap.FrequencyName}));
        }
        else{}

    }
    const updateAssetGateFre=(e)=>{
        if (e.value) {
        const newValue=e.value;
        setAssetGateFrequency(newValue);
        setTerms((value)=>({...value,AssetGateFrequencyId:newValue.FrequencyId,AssetGateFrequencyName:newValue.FrequencyName}))
        }
        else{}

    }   
    const updateNoticeFrequency=(e)=>{
        if (e.value) {
        const newValue=e.value;
        setNoticeFrequency(newValue);
        setTerms(value=>({...value,RequiredNoticeFrequencyId:newValue.EnumValue,RequiredNoticeFrequencyName:newValue.EnumName}));
        }
        else{}
    }
    const updateFirstRedemptionMonth=(e)=>{
        if(e.value)
        {
            const firstRedemptionMonth=e.value;
            setFirstRedemptionMonth(firstRedemptionMonth);
            setTerms((value)=>({...value,FirstRedemptionMonth:firstRedemptionMonth.MonthNr,FirstRedemptionMonthName:firstRedemptionMonth.MonthName}));
        }
    }
    const saveTerms=()=>{
        let saveSuccess=true;
        if (!Terms.RequiredNoticeFrequencyId || !checkIfNumber(Terms.RequiredNotice)) {
            saveSuccess = false;
            SBNotify({ type: "error", Msg: "Please Enter the Required Notice value and Select Notice Frequency" })
        }
        else if (!checkIfNumber(Terms.RedemptionFrequencyId))
        {
            saveSuccess = false;
            SBNotify({ type: "error", Msg: "Please Select Redemption Frequency" })
        }
        else if (Terms.RedemptionFrequencyId > 0 && !checkIfNumber(Terms.FirstRedemptionMonth) ) {
            saveSuccess = false;
            SBNotify({ type: "error", Msg: "Please Enter the First Redemption value" })
        }
        else if (!checkIfNumber(Terms.LockType) ) {
            saveSuccess = false;
            SBNotify({ type: "error", Msg: "Please Select the Lock Type" })
        }
        else if (Terms.LockupFrequencyId > 0 && (!checkIfNumber(Terms.LockupStart) || !checkIfNumber(Terms.LockupEnd) )) {
            saveSuccess = false;
            SBNotify({ type: "error", Msg: "Please Enter Both Lock Up Start and lock Up End value" })
        }
        else if (Terms.InvestorGateFrequencyId > 0 && !checkIfNumber(Terms.InvestorGatePercent) ) {
            saveSuccess = false;
            SBNotify({ type: "error", Msg: "Please Enter the Investor Gate Percent value" })
        }
        else if (Terms.InvestorGateCapResetFrequencyId > 0 && !checkIfNumber(Terms.InvestorGateMaxCapPercent) ) {
            saveSuccess = false;
            SBNotify({ type: "error", Msg: "Please Enter the Investor Gate Max Percent value" })
        }
        else if (Terms.AssetGateFrequencyId > 0 &&  !checkIfNumber(Terms.AssetGatePercent) ) {
            saveSuccess = false;
            SBNotify({ type: "error", Msg: "Please Enter the Asset Gate Percent value" })
        }
        
        if (saveSuccess) {
            const toSaveTerms = {
                "redemptionTermsId": Terms.RedemptionTermsId || 0,
                "shareClassid": Terms.ShareClassid || shareClassId,
                "lockType": Terms.LockType,
                "penaltyPercent": Terms.PenaltyPercent,
                "redemptionFeePercent": Terms.RedemptionFeePercent,
                "rollingLockup": Terms.RollingLockup,
                "anniversary": Terms.Anniversary,
                "redemptionFrequencyId": Terms.RedemptionFrequencyId,
                "lockupFrequencyId": Terms.LockupFrequencyId,
                "lockupStart": Terms.LockupStart,
                "lockupEnd": Terms.LockupEnd,
                "requiredNoticeFrequencyId": Terms.RequiredNoticeFrequencyId,
                "requiredNotice": Terms.RequiredNotice,
                "firstRedemptionMonth": Terms.FirstRedemptionMonth,
                "investorGateFrequencyId": Terms.InvestorGateFrequencyId,
                "investorGatePercent": Terms.InvestorGatePercent,
                "investorGateCapResetFrequencyId": Terms.InvestorGateCapResetFrequencyId,
                "investorGateMaxCapPercent": Terms.InvestorGateMaxCapPercent,
                "investorGateUseNav": Terms.InvestorGateFrequencyId  &&  Terms.InvestorGateUseNav && Terms.InvestorGateFrequencyId != 0 ? Terms.InvestorGateUseNav : false,
                "assetGateFrequencyId": Terms.AssetGateFrequencyId,
                "assetGatePercent": Terms.AssetGatePercent,
                "notes": Terms.Notes,
                "modifiedBy": 0
            };
            sbaAxios({
                url: `${postLiquidityTerms}`,
                method: 'post',
                data: toSaveTerms
            }).then(response => {
                setSelectedTerm(Terms);
                delayedSBNotify({ type: 'success', Msg: "Liquidity Terms Saved Successfully" });
                setRender(!render);
            }).catch(error => { console.log(error, "error saving Liquidity Terms") });
            setDrawerOpen(false);
        }
    }

   
    
    return <>
        <div className="mb-4"> 
            <input className="me-2"
                type="checkbox"
                checked={Terms.RollingLockup}
                onChange={()=>{
                    if (Terms.RollingLockup)
                        setTerms(Terms => ({ ...Terms, RollingLockup: false }))
                    else
                        setTerms(Terms => ({ ...Terms, RollingLockup: true, Anniversary: true }))
                }
                }
            />
            <span>
                Rolling Lock
            </span>
        </div>
        <div className="mb-4">
        <input className="me-2"
                type="checkbox"
                checked={Terms.Anniversary}
                onChange={()=>{setTerms(value=>({...value,Anniversary:!Terms.Anniversary}))}}
            />
            <span>
                Anniversary
            </span>
        </div>
        <div className="mb-4 d-inline-flex">
            <div className="w-50">
            <span>
                Required Notice <span class="mandatory">*</span>
            </span>
            <div >
            <input
                    className="form-control w-75"
                    type="number"
                    value={Terms.RequiredNotice}
                    onChange={(e)=>{
                        const newValue=parseInt(e.target.value) || 0;
                        if(!newValue ||  newValue>=0)
                        {
                            setTerms(Terms=>({...Terms,RequiredNotice:newValue}))
                        }
                        else
                        {
                            setTerms(Terms=>({...Terms,RequiredNotice:0}))
                        }
                    }}
                />
            </div>
            </div>
            <div className="w-50">
            <span>
                Notice Frequency <span class="mandatory">*</span>
            </span>
            <div >
            <SBAComboBox  popupSettings={{ className: 'modalDD' }} className="w-75" data={LiquidityRequriedNotice} value={NoticeFrequency} textField={'EnumName'} valueField={'EnumValue'}  onChange={updateNoticeFrequency} />
            </div>
            </div>
        </div>
        <div className="mb-4">
            <span>
                Redemption Frequency <span class="mandatory">*</span>
            </span>
            <div >
                <SBAComboBox  popupSettings={{ className: 'modalDD' }} className="w-75" data={Frequency1} textField={'FrequencyName'} valueField={'FrequencyId'} value={RedemptionFrequency}  onChange={updateRedemption} />
            </div>
        </div>
        <div className="mb-4">
            <span>
                First Redemption Month
            </span>
            <div >
            <SBAComboBox  popupSettings={{ className: 'modalDD' }} className="w-75" data={firstRedemptionDS} textField={'MonthName'} valueField={'MonthNr'} value={firstRedemptionMonth}  onChange={updateFirstRedemptionMonth} disabled={firstRedemptionDS.length===0} />
            </div>
        </div>
        <div className="mb-4">
            <span>
                Lock Type <span class="mandatory">*</span>
            </span>
            <div >
            <SBAComboBox  popupSettings={{ className: 'modalDD' }} className="w-75" data={LiquidityLockUpType}  textField={'EnumName'} valueField={'EnumValue'} value={LockType} onChange={updateLockType}/>
            </div>
        </div>
        <div className="mb-4">
            <span>
                Penality %
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="number"
                    value={Terms.PenaltyPercent}
                    onChange={(e)=>{setTerms((value)=>({...value,PenaltyPercent:parseFloat(e.target.value) || 0}))}}
                />
            </div>
        </div>
        <div className="mb-4">
            <span>
                Fee %
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="number"
                    value={Terms.RedemptionFeePercent}
                    onChange={(e)=>{setTerms((value)=>({...value,RedemptionFeePercent:parseFloat(e.target.value) || 0}))}}
                />
            </div>
        </div>
        <div className="mb-4">
            <span>
                Lockup Frequency
            </span>
            <div >
            <SBAComboBox  popupSettings={{ className: 'modalDD' }} className="w-75" data={LiquidityLockUpFrequency}  textField={'EnumName'} valueField={'EnumValue'} onChange={updateLockUpFrequency} value={LockUpFrequency} />
            </div>
        </div>
        <div className="mb-4">
            <span>
                Lockup Start
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="number"
                    value={Terms.LockupStart}
                    onChange={(e)=>{setTerms((value)=>({...value,LockupStart:parseInt(e.target.value) || 0}))}}
                />
            </div>
        </div>
        <div className="mb-4">
            <span>
                Lockup End
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="number"
                    value={Terms.LockupEnd}
                    onChange={(e)=>{setTerms((value)=>({...value,LockupEnd:parseInt(e.target.value) || 0}))}}
                />
            </div>
        </div>
        <div className="mb-4">
            <span>
                Investor Gate Frequency
            </span>
            <div >
                <SBAComboBox data={Frequency2}  popupSettings={{ className: 'modalDD' }} className="w-75" textField={'FrequencyName'} valueField={'FrequencyId'}  value={InvestorGate} onChange={updateInvestorGate}/>
            </div>
        </div>
        <div className="mb-4">
            <span>
                Investor Gate %
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="number"
                     value={Terms.InvestorGatePercent}
                    onChange={(e)=>{setTerms((value)=>({...value,InvestorGatePercent:parseFloat(e.target.value) || 0}))}}
                />
            </div>
        </div>
        <div className="mb-4">
            <span>
                Investor Gate Cap Reset Frequency
            </span>
            <div >
            <SBAComboBox data={Frequency2}  popupSettings={{ className: 'modalDD' }} className="w-75" textField={'FrequencyName'} valueField={'FrequencyId'} value={InvestorGateCapReset} onChange={updateInvestorGateCapReset}/>
            </div>
        </div>
        <div className="mb-4">
            <span>
                Investor Gate Max Cap %
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="number"
                    value={Terms.InvestorGateMaxCapPercent}
                    onChange={(e)=>{setTerms((value)=>({...value,InvestorGateMaxCapPercent:parseFloat(e.target.value)||0}))}}
                />
            </div>
        </div>
        <div className="mb-4">
        <input className="me-2"
                type="checkbox"
                disabled={InvestorGate.FrequencyId === 0 || InvestorGate.FrequencyId === null}
                checked={Terms.InvestorGateUseNav}
                onChange={()=>{setTerms(value=>({...value,InvestorGateUseNav:!Terms.InvestorGateUseNav}))}}
            />
            <span>
                Use NAV in calculations
            </span>
        </div>
        <div className="mb-4">
            <span>
            Asset Gate Frequency
            </span>
            <div >
            <SBAComboBox data={Frequency2}  popupSettings={{ className: 'modalDD' }} className="w-75" textField={'FrequencyName'} valueField={'FrequencyId'} value={AssetGateFrequency} onChange={updateAssetGateFre} />
            </div>
        </div>
        <div className="mb-4">
            <span>
            Asset Gate %
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="number"
                    value={Terms.AssetGatePercent}
                    onChange={(e) => { setTerms((value) => ({ ...value, AssetGatePercent: parseFloat(e.target.value) || 0 })) }}
                />
            </div>
        </div>
        <div className="mb-4">
            <span>
            Comments
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="text"
                    value={Terms.Notes}
                    onChange={(e) => { setTerms((value) => ({ ...value, Notes: e.target.value })) }}
                />
            </div>
        </div>
        <div className="d-flex">
            <button className="p-sm-btn mx-1" onClick={()=>{saveTerms()}}>{mode==="Add" ? "Add" : "Update"}</button>
            <button className="s-sm-btn mx-1" onClick={()=>{setTerms(nullTerms); setDrawerOpen(false)}}>Cancel</button>
        </div>
    </>
};



// payout section
const nullPayout = {
    "RedemptionPayoutId": null,
    "ShareClassId": null,
    "IsFullRedemption": false,
    "PayoutPercent": 0,
    "DaysToFirstPayout": null,
    "PayoutBasisId": null,
    "PayoutBasisName": null,
    "PayoutFromDateTypeId": null,
    "PayoutFromDateTypeName": null,
    "HoldbackPayoutPercent": null,
    "DaysToFirstHoldbackPayout": null,
    "HoldbackPayoutBasisId": null,
    "HoldbackPayoutBasisName": null,
    "HoldbackPayoutFromDateTypeId": null,
    "HoldbackPayoutFromDateTypeName": null,
    "HalfPayoutPercent": 0,
    "HalfDaysToFirstPayout": null,
    "HalfPayoutBasisId": null,
    "HalfPayoutBasisName": null,
    "HalfPayoutFromDateTypeId": null,
    "HalfPayoutFromDateTypeName": null,
    "HalfHoldbackPayoutPercent": null,
    "HalfDaysToFirstHoldbackPayout": null,
    "HalfHoldbackPayoutBasisId": null,
    "HalfHoldbackPayoutBasisName": null,
    "HalfHoldbackPayoutFromDateTypeId": null,
    "HalfHoldbackPayoutFromDateTypeName": null
    
};
const Payouts = ({ payoutData, setRender ,render ,shareClassId  }) => {
    const [payoutGridData,setPayoutGridData]=useState([]);
    const [isEditPayout,setIsEditPayout]=useState(false);
    const [selectedPayout,setSelectedPayout]=useState(nullPayout);
    const [isDeletePayout,setIsDeletePayout]=useState(false);
    const [drawerMode,setDrawerMode]=useState(null);

    const Gstate = useSelector((state) => state) || {};
    const isEditable =Gstate.authorizationData.isEditable;
    const shareClassList = Gstate?.assetShareClass?.assetShareClass || [];

    const payoutColDef = [
        { field: "Payout", headerName: "Payout" },
        { field: "PayoutPercent", headerName: "Payout %" },
        { field: "FirstPayoutPeriod", headerName: "Payout Period" },
        { field: "PayoutBasisName", headerName: "Initial Calendar" },
        { field: "PayoutFromDateTypeName", headerName: "From Date" },
        { field: "HoldbackPayoutPercent", headerName: "Holdback Payout %" },
        { field: "FirstHoldbackPayoutPeriod", headerName: "Holdback Period " },
        { field: "HoldbackPayoutBasisName", headerName: "Holdback Calendar" },
        { field: "HoldbackPayoutFromDateTypeName", headerName: "Holdback From Date" },
        { field: "", headerName: "Action"  ,minWidth: 100,cellRenderer:(rowData)=>{return <div className="actions-cell"><i className="fas fa-edit" style={{ color: isEditable === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}  onClick={()=>editPayout(rowData)}></i></div>} },
    ];
    useEffect(()=>{
            setPayoutGridData(payoutData.map((item) => {
                if (item.IsFullRedemption)
                    return { ...item, Payout: "Full" }
                else
                    return { ...item, Payout: "Partial" }
            })|| []);
    },[]);
    const addPayout=()=>{
        if(isEditable !== false){
        setDrawerMode("Add");
        setIsEditPayout(true);
        }
    };
    const deletePayout=()=>{
        if(isEditable !== false){
            setIsDeletePayout(true);
        }
    }
    const deleteLiquidityPayouts=()=>{
        sbaAxios({url:`${deleteLiquidityPayoutsAPI}${shareClassId}`}).then(()=>{
            delayedSBNotify({Msg:"Liquidity Payout Deleted Successfully"});
            setIsDeletePayout(false);
            setRender(!render);
        }).catch(e=>{
            console.log(e,'Error deleting Payouts')
        })
    };
    
    const editPayout=(e)=>{
        if(isEditable !== false){
            setDrawerMode("Edit");
            setSelectedPayout(e.data);
            setIsEditPayout(true);
        }
    };
 
    return <div className="my-4">
        Payouts
        <div className="detail p-2">
            {<>
        <div className="row m-0">
              {shareClassList.length>0 && <div className="col-md-1 ms-auto" style={{ width: "max-content" }} >
                    {payoutGridData.length===0 && <>  <i className="fa-solid fa-add ms-auto text-success" disabled={!isEditable} onClick={() => { addPayout() }}></i></>}
                    {/* {payoutGridData.length===2 && <>  <i className="fa-solid fa-edit ms-auto text-success" onClick={() => { editPayout() }}></i></>} */}
                    {payoutGridData.length>0 && <><i className="fa-solid fa-trash mx-3" style={{ color: isEditable === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={() => { deletePayout()}}></i></>}
                </div>}
            </div></>}
            <div className="ag-theme-alpine">
                <AgGridReact rowData={payoutGridData} rowSelection="single" columnDefs={payoutColDef} defaultColDef={defColDef} />
            </div>
        </div>
        <SBADrawer  size={'lg'} open={isEditPayout} setOpen={setIsEditPayout} title={drawerMode==="Edit" ? "Edit Payout": "Add Payout"} >
            {drawerMode === "Add" && <> <PayoutAdder selectedPayout={selectedPayout} payoutGridData={payoutGridData} setIsEditPayout={setIsEditPayout} setRender={setRender} render={render} shareClassId={shareClassId} drawerMode={drawerMode} /></>}
            {drawerMode === "Edit" && <> <PayoutEditor selectedPayout={selectedPayout} payoutGridData={payoutGridData} setIsEditPayout={setIsEditPayout} setRender={setRender} render={render} shareClassId={shareClassId} drawerMode={drawerMode} /></>}

        </SBADrawer>
        <LiquidityDeleteModal showModal={isDeletePayout} title={"Delete Redemption Payouts ?"} setShowModal={setIsDeletePayout} deleteLiquidity={deleteLiquidityPayouts} >
        <p>
          The selected Liquidity Redemption Payouts will be deleted permanently. Are you sure?
        </p>
        </LiquidityDeleteModal>
    </div>
};
const InsertAndUpdatePayOut=({payout,setPayout,drawerMode,setRender,render,payoutSection})=>{
    const [payoutBasic,setPayoutBasic]=useState({RedemptionPayoutBasisId:payout?.PayoutBasisId,RedemptionPayoutBasisName:payout?.PayoutBasisName});
    const [holdbackPayoutBasic,setHoldbackPayoutBasic]=useState({RedemptionPayoutBasisId:payout?.HoldbackPayoutBasisId,RedemptionPayoutBasisName:payout?.HoldbackPayoutBasisName});
    const [payoutFromDate,setPayoutFromDate]=useState({RedemptionPayoutFromDateTypeId:payout?.PayoutFromDateTypeId,RedemptionPayoutFromDateTypeName:payout?.PayoutFromDateTypeName});
    const [holdbackPayoutFromDate,setHoldbackPayoutFromDate]=useState({RedemptionPayoutFromDateTypeId:payout?.HoldbackPayoutFromDateTypeId,RedemptionPayoutFromDateTypeName:payout?.HoldbackPayoutFromDateTypeName});
    const [fromDataDs,setFromDataDs]=useState([]);
    const [basicDs,setBasicDs]=useState([]);
    useEffect(()=>{
        sbaAxios({url:getLiquidityFromDateDS}).then(response=>{
            setFromDataDs(response);
        }).catch(error=>{
            console.log(error,'Error Fetching data For Liquidity From Date');
        });
        sbaAxios({url:getLiquidityBasicsDS}).then(response=>{
            setBasicDs(response)
        }).catch(error=>{
            console.log(error,'Error Fetching data For Liquidity Basic');
        })
    },[]);
    useEffect(()=>{
        setPayoutBasic({RedemptionPayoutBasisId:payout?.PayoutBasisId,RedemptionPayoutBasisName:payout?.PayoutBasisName});
        setHoldbackPayoutBasic({RedemptionPayoutBasisId:payout?.HoldbackPayoutBasisId,RedemptionPayoutBasisName:payout?.HoldbackPayoutBasisName});
        setPayoutFromDate({RedemptionPayoutFromDateTypeId:payout?.PayoutFromDateTypeId,RedemptionPayoutFromDateTypeName:payout?.PayoutFromDateTypeName});
        setHoldbackPayoutFromDate({RedemptionPayoutFromDateTypeId:payout?.HoldbackPayoutFromDateTypeId,RedemptionPayoutFromDateTypeName:payout?.HoldbackPayoutFromDateTypeName})
    },[payout]);
   
    const updateHoldBackBasic=(e)=>{
        if(e.value){
        const newValue=e.value;
            setHoldbackPayoutBasic(newValue);
            setPayout({...payout,HoldbackPayoutBasisId:newValue.RedemptionPayoutBasisId,HoldbackPayoutBasisName:newValue.RedemptionPayoutBasisName})
        }
    };
    const updateHoldBackFromDate=(e)=>{
        if(e.value){
            const newValue=e.value;
                setHoldbackPayoutFromDate(newValue);
                setPayout({...payout,HoldbackPayoutFromDateTypeId:newValue.RedemptionPayoutFromDateTypeId,HoldbackPayoutFromDateTypeName:newValue.RedemptionPayoutFromDateTypeName})
            }
    };
    const updatePayoutBasic=(e)=>{
        if(e.value){
            const newValue=e.value;
                setPayoutBasic(newValue);
                setPayout({...payout,PayoutBasisId:newValue.RedemptionPayoutBasisId,PayoutBasisName:newValue.RedemptionPayoutBasisName})
            }
    };
    const updatePayoutFromDate=(e)=>{
        if(e.value){
            const newValue=e.value;
                setPayoutFromDate(newValue);
                setPayout({...payout,PayoutFromDateTypeId:newValue.RedemptionPayoutFromDateTypeId,PayoutFromDateTypeName:newValue.RedemptionPayoutFromDateTypeName})
            }
    };
    return <>
         <div className="mb-4"> 
        </div>
        <div >
        <div className="mb-4">
        <h4>{payoutSection}</h4>
    <span>
        Payout Percent
    </span>
    <div>
        <input
            className="form-control w-75"
            type="number"
            value={payout?.PayoutPercent === null ? '' : payout?.PayoutPercent}
            onChange={(e) => {
                const newValue = !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) :  null;
                const remainingValue = newValue === null ? 100 : 100 - (newValue || 0);
                if (newValue >= 0 && newValue<=100)
                    setPayout((value) => ({
                        ...value,
                        HoldbackPayoutPercent: remainingValue,
                        PayoutPercent: newValue,
                    }));
                else if (newValue > 100)
                    setPayout((value) => ({
                        ...value,
                        HoldbackPayoutPercent: 0,
                        PayoutPercent: 100,
                    }));
                else
                    setPayout((value) => ({
                        ...value,
                        HoldbackPayoutPercent: 100,
                        PayoutPercent: 0,
                    }));
            }}
        />
    </div>
</div>
        <div className="mb-4">
            <span>
                First Payout Period
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="number"
                    value={payout?.FirstPayoutPeriod}
                    onChange={(e)=>{
                        const newValue=parseInt(e.target.value) || 0;
                        if(newValue>0) 
                        setPayout(value=>( {...value,FirstPayoutPeriod:newValue}))
                        else
                        setPayout(value=>( {...value,FirstPayoutPeriod:0}))
                    }}
                />
            </div>
        </div>
        <div className="mb-4">
            <span>
            Payout Basis <span class="mandatory">*</span>
            </span>
            <div >
            <SBAComboBox  popupSettings={{ className: 'modalDD' }} className="w-75" data={basicDs} textField={'RedemptionPayoutBasisName'} valueField={'RedemptionPayoutBasisId'} value={payoutBasic} onChange={updatePayoutBasic} />
            </div>
        </div>
        <div className="mb-4">
            <span>
            Payout From Date Type <span class="mandatory">*</span>
            </span>
            <div >
            <SBAComboBox  popupSettings={{ className: 'modalDD' }} className="w-75" data={fromDataDs} textField={'RedemptionPayoutFromDateTypeName'} valueField={'RedemptionPayoutFromDateTypeId'} value={payoutFromDate} onChange={updatePayoutFromDate}/>
            </div>
        </div>
        <div className="mb-4">
    <span>
        Holdback Payout Percent
    </span>
    <div>
        <input
            className="form-control w-75"
            type="number"
            value={
                payout?.HoldbackPayoutPercent === null
                    ? ''
                    : payout?.HoldbackPayoutPercent
            }
                        onChange={(e) => {
                            const newValue = !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) :  null;
                            const remainingValue = newValue === null ? 100 : 100 - (newValue || 0);
                            if (newValue >= 0 && newValue<=100)
                                setPayout((value) => ({
                                    ...value,
                                    HoldbackPayoutPercent: newValue,
                                    PayoutPercent: remainingValue,
                                }));
                            else if (newValue > 100)
                                setPayout((value) => ({
                                    ...value,
                                    HoldbackPayoutPercent: 100,
                                    PayoutPercent: 0,
                                }));
                            else
                                setPayout((value) => ({
                                    ...value,
                                    HoldbackPayoutPercent: 0,
                                    PayoutPercent: 100,
                                }));
                        }}
        />
    </div>
</div>
        <div className="mb-4">
            <span>
            First Holdback Payout Period
            </span>
            <div >
                <input
                    className="form-control w-75"
                    type="number"
                    value={payout?.FirstHoldbackPayoutPeriod}
                    onChange={(e)=>{
                        const newValue=parseInt(e.target.value) || 0;
                        if(newValue>0) 
                        setPayout(value=>({...value,FirstHoldbackPayoutPeriod:newValue}))
                        else
                        setPayout(value=>({...value,FirstHoldbackPayoutPeriod: 0}))
                    }}
                />
            </div>
        </div>
        <div className="mb-4">
            <span>
                Holdback Payout Basis <span class="mandatory">*</span>
            </span>
            <div >
                <SBAComboBox popupSettings={{ className: 'modalDD' }} className="w-75" data={basicDs} textField={'RedemptionPayoutBasisName'} valueField={'RedemptionPayoutBasisId'} value={holdbackPayoutBasic}  onChange={updateHoldBackBasic}/>
            </div>
        </div>
        <div className="mb-4">
            <span>
                Holdback Payout From Date <span class="mandatory">*</span>
            </span>
            <div >
                <SBAComboBox popupSettings={{ className: 'modalDD' }} className="w-75" data={fromDataDs} textField={'RedemptionPayoutFromDateTypeName'} valueField={'RedemptionPayoutFromDateTypeId'} value={holdbackPayoutFromDate}  onChange={updateHoldBackFromDate}/>
            </div>
        </div>
        </div>
       
    </>
};
const PayoutAdder=({setIsEditPayout,setRender,render,payoutGridData,shareClassId ,drawerMode})=>{
    const [fullPayout,setFullPayout]=useState({...nullPayout,  "PayoutPercent": 100});
    const [partialPayout, setPartialPayout] = useState({
        ...nullPayout, 
        "PayoutPercent": 100,
        "PayoutBasisId": 2,
        "PayoutBasisName": "Calendar Days",
        "PayoutFromDateTypeId": 1,
        "PayoutFromDateTypeName": "NAV Date",
        "HoldbackPayoutPercent": 0,
        "HoldbackPayoutBasisId": 2,
        "HoldbackPayoutBasisName": "Calendar Days",
        "HoldbackPayoutFromDateTypeId": 2,
        "HoldbackPayoutFromDateTypeName": "Audit Date",
        "FirstPayoutPeriod": 30,
        "FirstHoldbackPayoutPeriod": 0
    });
    useEffect(()=>{
        setFullPayout({...nullPayout,
            "PayoutBasisId": 2,
            "PayoutBasisName": "Calendar Days",
            "PayoutFromDateTypeId": 1,
            "PayoutFromDateTypeName": "NAV Date",
            "HoldbackPayoutBasisId": 2,
            "HoldbackPayoutBasisName": "Calendar Days",
            "HoldbackPayoutFromDateTypeId": 1,
            "HoldbackPayoutFromDateTypeName": "NAV Date",
            "PayoutPercent": 100
        });
        setPartialPayout({
            ...nullPayout,
            "PayoutPercent": 100,
            "PayoutBasisId": 2,
            "PayoutBasisName": "Calendar Days",
            "PayoutFromDateTypeId": 1,
            "PayoutFromDateTypeName": "NAV Date",
            "HoldbackPayoutPercent": 0,
            "HoldbackPayoutBasisId": 2,
            "HoldbackPayoutBasisName": "Calendar Days",
            "HoldbackPayoutFromDateTypeId": 2,
            "HoldbackPayoutFromDateTypeName": "Audit Date",
            "FirstPayoutPeriod": 30,
            "FirstHoldbackPayoutPeriod": 0
        });
    },[]);
    const updatePayout=()=>{
        if (fullPayout?.PayoutBasisId && fullPayout?.PayoutFromDateTypeId && fullPayout?.HoldbackPayoutBasisId && fullPayout?.HoldbackPayoutFromDateTypeId &&
            partialPayout?.PayoutBasisId && partialPayout?.PayoutFromDateTypeId && partialPayout?.HoldbackPayoutBasisId && partialPayout?.HoldbackPayoutFromDateTypeId
        ) {
            
        const updatedPayout = [{
            "redemptionPayoutId": fullPayout.RedemptionPayoutId || 0,
            "shareClassId": fullPayout?.ShareClassId || shareClassId,
            "isFullRedemption": true,
            "payoutPercent": fullPayout.PayoutPercent || 100,
            "firstPayoutPeriod": fullPayout.FirstPayoutPeriod || 0,
            "payoutBasisId": fullPayout.PayoutBasisId,
            "payoutFromDateTypeId": fullPayout.PayoutFromDateTypeId,
            "holdbackPayoutPercent": fullPayout.HoldbackPayoutPercent || 0,
            "firstHoldbackPayoutPeriod": fullPayout.FirstHoldbackPayoutPeriod || 0,
            "holdbackPayoutBasisId": fullPayout.HoldbackPayoutBasisId,
            "holdbackPayoutFromDateTypeId": fullPayout.HoldbackPayoutFromDateTypeId,
            "modifiedBy": 0
        },
        {
            "redemptionPayoutId": partialPayout.RedemptionPayoutId || 0,
            "shareClassId": partialPayout.ShareClassId || shareClassId,
            "isFullRedemption": false,
            "payoutPercent": partialPayout.PayoutPercent || 0,
            "firstPayoutPeriod": partialPayout.FirstPayoutPeriod || 0,
            "payoutBasisId": partialPayout.PayoutBasisId,
            "payoutFromDateTypeId": partialPayout.PayoutFromDateTypeId,
            "holdbackPayoutPercent": partialPayout.HoldbackPayoutPercent || 100,
            "firstHoldbackPayoutPeriod": partialPayout.FirstHoldbackPayoutPeriod || 0,
            "holdbackPayoutBasisId": partialPayout.HoldbackPayoutBasisId,
            "holdbackPayoutFromDateTypeId": partialPayout.HoldbackPayoutFromDateTypeId,
            "modifiedBy": 0
        }

        ];
            sbaAxios({url:postLiquidityPayout,method:'post',data:updatedPayout}).then(response=>{
                delayedSBNotify({Msg:"Payout Saved Successfully"})
                setRender(!render);
                setIsEditPayout(false);
              }).catch(e=>{
                console.log(e,'error while Payout saving')
              })
        }
        else
        {
            SBNotify({Msg:"Please Enter all the Mandatory Fields", type:'error'});
        };
       
    };
    return <>
        <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: 1 }}>
                <InsertAndUpdatePayOut payout={fullPayout} setPayout={setFullPayout} drawerMode={setIsEditPayout} setRender={setRender} render={render} payoutSection={"Full"} />
            </div>
            <div style={{ flex: 1 }}>
                <InsertAndUpdatePayOut payout={partialPayout} setPayout={setPartialPayout} drawerMode={setIsEditPayout} setRender={setRender} render={render} payoutSection={"Partial"} />
            </div>
        </div>
        <div className="d-flex">
            <button className="s-sm-btn mx-1" onClick={() => { setIsEditPayout(false) }}>Cancel</button>
            <button className="p-sm-btn mx-1" onClick={() => { updatePayout() }}> {"Add"}</button>
        </div>
    </>
}
const PayoutEditor=({setIsEditPayout,setRender,render,payoutGridData,shareClassId,selectedPayout})=>{
    const [payout,setPayout]=useState(selectedPayout);
    useEffect(()=>{
        setPayout(selectedPayout);
    },[]);
    const updatePayout=()=>{
        if (payout?.PayoutBasisId && payout?.PayoutFromDateTypeId && payout?.HoldbackPayoutBasisId && payout?.HoldbackPayoutFromDateTypeId) {
            
        const updatedPayout = [{
            "redemptionPayoutId": payout.RedemptionPayoutId || 0,
            "shareClassId": payout?.ShareClassId || shareClassId,
            "isFullRedemption": payout.IsFullRedemption,
            "payoutPercent": payout.PayoutPercent || 100,
            "firstPayoutPeriod": payout.FirstPayoutPeriod || 0,
            "payoutBasisId": payout.PayoutBasisId,
            "payoutFromDateTypeId": payout.PayoutFromDateTypeId,
            "holdbackPayoutPercent": payout.HoldbackPayoutPercent || 0,
            "firstHoldbackPayoutPeriod": payout.FirstHoldbackPayoutPeriod || 0,
            "holdbackPayoutBasisId": payout.HoldbackPayoutBasisId,
            "holdbackPayoutFromDateTypeId": payout.HoldbackPayoutFromDateTypeId,
            "modifiedBy": 0
        }
        ];
            sbaAxios({url:postLiquidityPayout,method:'post',data:updatedPayout}).then(response=>{
                delayedSBNotify({Msg:"Payout Saved Successfully"})
                setRender(!render);
                setIsEditPayout(false);
              }).catch(e=>{
                console.log(e,'error while Payout saving')
              })
        }
        else
        {
            SBNotify({Msg:"Please Enter all the Mandatory Fields", type:'error'});
        };
    }
    return <>
    <InsertAndUpdatePayOut payout={payout} setPayout={setPayout} drawerMode={setIsEditPayout} setRender={setRender} render={render} payoutSection={payout.Payout} />
    <div className="d-flex">
            <button className="s-sm-btn mx-1" onClick={() => { setIsEditPayout(false) }}>Cancel</button>
            <button className="p-sm-btn mx-1" onClick={() => { updatePayout() }}> {"Update"}</button>
        </div>
    </>
}



const LiquidityDeleteModal=({showModal,setShowModal,children,title,deleteLiquidity})=>{
    const closeModal=()=>{
        setShowModal(false);
    };
    return <Modal show={showModal}>
    <Modal.Header closeButton onClick={setShowModal}>
      <Modal.Title>
      {title}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
      {children}
      </p>
    </Modal.Body>
    <Modal.Footer>
      <button className="s-sm-btn mx-1" onClick={closeModal}>
        Cancel
      </button>
      <button
        className="p-sm-btn mx-1"
        onClick={()=>{deleteLiquidity()}}
      >
        Yes
      </button>
    </Modal.Footer>
  </Modal>
}
const delayedSBNotify=({ Msg , ...props })=>{
    setTimeout(()=>{
        SBNotify({Msg,...props})
    },100) 
}